import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { loadFederatedChildAgencies } from '~/api/data/agencies/queries';
import { loadExcelSpreadsheetTemplates } from '~/api/data/excel-templates/queries';
import { loadCustomForms } from '~/api/data/forms/queries';
import { loadHtmlDocumentTemplates } from '~/api/data/html-templates/queries';
import {
  submitArchiveCustomPresets,
  submitCreateCustomPreset,
  submitUpdateCustomPreset
} from '~/api/data/presets/mutations';
import { loadCustomPreset, loadCustomPresets } from '~/api/data/presets/queries';
import { loadWordDocumentTemplates } from '~/api/data/word-templates/queries';
import {
  PresetCreatePage,
  PresetEditPage,
  PresetRunPage,
  PresetsPage
} from '~/pages/presets/presets';

export const presetsRoute: RouteObject = {
  path: 'presets',
  loader: merge({
    presets: loadCustomPresets,
    federatedChildAgencies: loadFederatedChildAgencies
  }),
  element: <PresetsPage />,
  children: [
    {
      path: 'archive',
      action: byMethod({
        POST: submitArchiveCustomPresets
      })
    },
    {
      path: 'new',
      loader: merge({
        customForms: loadCustomForms,
        htmlDocumentTemplates: loadHtmlDocumentTemplates,
        wordDocumentTemplates: loadWordDocumentTemplates
      }),
      shouldRevalidate: () => false,
      action: byMethod({
        POST: submitCreateCustomPreset
      }),
      element: <PresetCreatePage />
    },
    {
      path: ':id/edit',
      loader: merge({
        preset: loadCustomPreset,
        customForms: loadCustomForms,
        htmlDocumentTemplates: loadHtmlDocumentTemplates,
        wordDocumentTemplates: loadWordDocumentTemplates
      }),
      action: byMethod({
        PUT: submitUpdateCustomPreset
      }),
      element: <PresetEditPage />
    },
    {
      path: ':id/run',
      loader: merge({
        preset: loadCustomPreset,
        customForms: loadCustomForms,
        htmlDocumentTemplates: loadHtmlDocumentTemplates,
        wordDocumentTemplates: loadWordDocumentTemplates,
        excelSpreadsheetTemplates: loadExcelSpreadsheetTemplates
      }),
      element: <PresetRunPage />
    }
  ]
};
